import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let dropPromise = null;
const getDrop = () => {
  if (!dropPromise) dropPromise = api.get("/drop-info").then((r) => r.data).catch(() => null);
  return dropPromise;
};

const pad = (n) => String(n).padStart(2, "0");

function useCountdown() {
  const [target, setTarget] = useState(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    getDrop().then((d) => d?.date && setTarget(new Date(d.date).getTime()));
  }, []);

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!target) return null;
  const diff = target - now;
  if (diff <= 0) return { live: true };
  return {
    live: false,
    d: Math.floor(diff / 86400000),
    h: Math.floor(diff / 3600000) % 24,
    m: Math.floor(diff / 60000) % 60,
    s: Math.floor(diff / 1000) % 60,
  };
}

export default function DropCountdown({ variant = "small", className = "" }) {
  const c = useCountdown();

  if (!c) {
    return (
      <span className={`font-mono2 text-[10px] tracking-[0.25em] uppercase text-gold/70 ${className}`} data-testid="drop-countdown">
        Drop 002 — Soon
      </span>
    );
  }

  if (c.live) {
    return (
      <span className={`font-mono2 text-[10px] tracking-[0.25em] uppercase text-gold ${className}`} data-testid="drop-countdown">
        Drop 002 — Live Now
      </span>
    );
  }

  if (variant === "large") {
    const cells = [[c.d, "Days"], [c.h, "Hours"], [c.m, "Min"], [c.s, "Sec"]];
    return (
      <div className={`grid grid-cols-4 gap-2 ${className}`} data-testid="drop-countdown">
        {cells.map(([v, l]) => (
          <div key={l} className="border border-gold/25 bg-noir-bg/40 py-3 sm:py-4 text-center">
            <div className="font-display font-bold text-xl sm:text-2xl text-gold tabular-nums" data-testid={`countdown-${l.toLowerCase()}`}>{pad(v)}</div>
            <div className="font-mono2 text-[8px] tracking-[0.3em] uppercase text-cream/40 mt-1">{l}</div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <span className={`font-mono2 text-[10px] tracking-[0.2em] uppercase text-gold/80 tabular-nums ${className}`} data-testid="drop-countdown">
      Drop 002 — T−{c.d}d {pad(c.h)}h {pad(c.m)}m {pad(c.s)}s
    </span>
  );
}
